import React, { useEffect } from 'react';
import './../styles/service-page.css';

const SolarPanelCleaningPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Parallax effect for hero background
    // const handleScroll = () => {
    //   const scrolled = window.scrollY;
    //   const heroBackground = document.querySelector('.hero-section');
    //   if (heroBackground && scrolled < 600) {
    //     const yPos = -(scrolled * 0.5);
    //     heroBackground.style.backgroundPositionY = `${yPos}px`;
    //   }
    // };

    // window.addEventListener('scroll', handleScroll);

    // Add scroll animations matching homepage
    const observeElements = () => {
      const elements = document.querySelectorAll('.slide-in-up, .slide-in-left, .slide-in-right');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(element => {
        observer.observe(element);
      });

      // Stagger animations for service cards
      const cards = document.querySelectorAll('.service-card');
      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 0.1}s`;
      });

      // Stagger process steps
      const steps = document.querySelectorAll('.process-step');
      steps.forEach((step, index) => {
        step.style.transitionDelay = `${index * 0.15}s`;
      });
    };

    setTimeout(observeElements, 100);

    // Cleanup
    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  return (
    <div className="service-page">
      {/* Hero Section with Background Image */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('https://media.istockphoto.com/id/514536277/photo/dirty-solar-panels.jpg?s=612x612&w=0&k=20&c=92jXcg6PDdjv1nBS7DgiDi-kWu5YODnzJ-_1jMiq0Dg=')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="header-content slide-in-up">
            <h1>Solar Panel Cleaning</h1>
            <p className="header-subtitle">
              Professional solar panel cleaning to maximize energy efficiency. Gentle, effective cleaning that removes dirt, bird droppings, and buildup safely.
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
<section className="service-overview">
  <div className="container">
    <div className="overview-grid">
      <div className="overview-content slide-in-left">
        <h2>Why Choose Our Solar Panel Cleaning Service?</h2>
        <p>
          Dirty solar panels can lose up to 30% of their efficiency, directly impacting 
          your energy savings and return on investment. Bird droppings, dust, pollen, and 
          air pollution create a film that blocks sunlight from reaching the photovoltaic 
          cells, significantly reducing your system's power output.
        </p>
        <p>
          Our professional solar panel cleaning service uses purified water and specialized 
          soft brushes to safely restore your panels to peak performance. We follow 
          manufacturer guidelines to maintain your warranty, using eco-friendly methods that 
          leave no residue. Regular cleaning ensures maximum energy generation year-round.
        </p>
        <div className="key-benefits">
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Increases energy output by up to 30%</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Purified water – no chemical residue</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Warranty-safe cleaning methods</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Full system health check included</span>
          </div>
        </div>
      </div>
      <div className="overview-image slide-in-right">
        <img src="https://media.istockphoto.com/id/500305259/photo/cleaning-moduls-electricity.jpg?s=612x612&w=0&k=20&c=Pqz_uuXreRDEjpUCAozYS1kc3C9feU6fWJnt4_dw3KU=" alt="Professional solar panel cleaning service" />
      </div>
    </div>
  </div>
</section>

      {/* What's Included */}
      <section className="whats-included">
        <div className="container">
          <h2 className="section-title slide-in-up">What's Included in Our Solar Panel Cleaning Service</h2>
          
          <div className="services-grid">
            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🗲</span>
              </div>
              <h3>Efficiency Restoration</h3>
              <p>
                Professional cleaning that can restore up to 30% of lost energy efficiency by removing performance-reducing dirt and debris.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🧼</span>
              </div>
              <h3>Gentle Cleaning Method</h3>
              <p>
                Specialized techniques and tools designed specifically for delicate solar panel surfaces without risk of scratching or damage.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🔬</span>
              </div>
              <h3>Deionized Water System</h3>
              <p>
                Pure, deionized water cleaning that leaves no mineral spots or residue, ensuring maximum light transmission.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>📊</span>
              </div>
              <h3>Performance Testing</h3>
              <p>
                Before and after efficiency measurements to document the improvement in your solar system\'s energy production.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>♻️</span>
              </div>
              <h3>Eco-Safe Products</h3>
              <p>
                All our cleaning products are environmentally friendly and safe for your family, 
                pets, and surrounding landscaping while still being tough on dirt and stains.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>✅</span>
              </div>
              <h3>Quality Guarantee</h3>
              <p>
                We stand behind our work with a complete satisfaction guarantee. If you're not 
                happy with the results, we'll return to address any concerns at no extra cost.
              </p>
            </div>
          </div>
        </div>
      </section>

            {/* SupremeCoat Overview */}
<section className="service-overview">
  <div className="container">
    <div className="overview-grid">
      <div className="overview-content slide-in-left">
        <h2>Why Choose Our Supremecoat Solar Protection?</h2>
    <p>
          Dirty solar panels lose efficiency from dust, water spots, and environmental damage. 
          The US Department of Energy confirms that reducing sunlight reflection increases 
          efficiency by 3-6%. Supremecoat Solar provides 4 years of ceramic protection.
        </p>
        <p>
          Our ultra-thin coating creates a hydrophobic, self-cleaning barrier that's 100% 
          optically clear and safe for all panel types. This advanced ceramic technology 
          reduces maintenance costs while protecting against erosion and staining.
        </p>
        <div className="key-benefits">
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Increases efficiency by 3-6%</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Super-hydrophobic water repellent coating</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Up to 4 years of durable protection</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>100% optically clear - no light reduction</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Frost resistant - easy snow/ice removal</span>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <span>Self-cleaning properties reduce maintenance</span>
          </div>
        </div>
      </div>
      <div className="overview-image slide-in-right">
        <img src="http://reuters.com/resizer/v2/MVJ6K7HCAZL7RHERV7L5UX52Z4.jpg?auth=d6a90e1dd7a2606cd06bb0b7eb0b3f34edd174adb27270cc59e8138c6b8459e0&width=5382&quality=80" alt="Supremecoat Solar protected panels" />
      </div>
    </div>
  </div>
</section>

      {/* Our Process */}
      <section className="our-process">
        <div className="container">
          <h2 className="section-title slide-in-up">Our Simple 4-Step Process</h2>
          
          <div className="process-steps">
            <div className="process-step slide-in-left">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Free Quote & Assessment</h3>
                <p>
                  Contact us for a free, no-obligation quote. We'll assess your Solar Panels 
                  condition and provide you with a detailed estimate of the work required.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Preparation & Setup</h3>
                <p>
                  We'll protect your property and surrounding areas, then apply pre-treatment 
                  solutions to problem areas and set up our professional cleaning equipment.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-left">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Professional Cleaning</h3>
                <p>
                  Using the correct pressure settings for your Solar Panel material, we systematically 
                  clean every area, paying special attention to stained and heavily soiled sections.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Final Inspection</h3>
                <p>
                  We conduct a thorough quality check to ensure all areas have been properly cleaned, 
                  and discuss optional protective treatments to maintain your Solar Panels appearance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content slide-in-up">
            <h2>Ready to Restore Your Solar Panels?</h2>
            <p>
              Get your free quote today and see how we can transform your Solar Panels appearance. 
              Most quotes provided within 24 hours with no obligation to proceed.
            </p>
            <div className="cta-buttons">
              <a href="/#contact" className="btn btn-primary">Get Free Quote</a>
            </div>
            <div className="cta-assurance">
              <span>✓ Fully insured</span>
              <span>✓ Satisfaction guaranteed</span>
              <span>✓ Free quotes</span>
              <span>✓ No hidden fees</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SolarPanelCleaningPage;